import styled from 'styled-components';
import colors from 'constants/colors';

export const CommunicationContainer = styled.div`
  flex-basis: 100%;
  padding: 15px;

  & > div:first-child {
    background-color: ${colors.black5};
  }

  & > div {
    color: ${colors.white};
    background-color: ${colors.black2};
    display: flex;
    flex-wrap: wrap;
  }
`;

export const MobileCommunicationContainer = styled.div`
  display: flex;
  flex-basis: 100%;
  align-items: center;
  justify-content: center;
  height: 92px;
  padding: 0 30px;

  img {
    margin-right: 10px;  
  } 

  @media only screen and (min-width: 1200px) {
    display: none;
  }

  @media only screen and (max-width: 767px) {
    height: 107px;
  }
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  column-gap: 16px;

  .email, .phone, .address, .city, .province, .zipCode, .country {
    width: 100%;
    min-width: 60px;
    position: relative;

    .label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
